import { instanceConexao } from "services/axiosServices";
import { AxiosRequestConfig } from "axios";
import { FileUploadI } from "../utils";

export const putCreciAutonomo = async (params: {
  idAutonomo: string;
  idTipoCreci: string;
  numero: string;
  numeroJuridico?: string;
  dataVencimento: Date | null;
  dataVencimentoJuridico?: Date | null;
  carteiraFrente: FileUploadI | null;
  carteiraVerso: FileUploadI | null;
  isJuridico: boolean;
  razaoSocial?: string;
  cnpj?: string;
  codigoVerificacao?: string;
  enderecoFiscal?: string;
  escolaTTi?: string;
  carteiraCreciJuridicoFrente?: FileUploadI | null;
  carteiraCreciJuridicoVerso?: FileUploadI | null;
  cartaoCNPJ?: FileUploadI | null;
  authToken: string;
}): Promise<any> => {
  const url = "/api/alteracaoAutonomo/AtualizaCreciAlteracaoAutonomo";
  const { authToken, ...parameters } = params;
  const config: AxiosRequestConfig = {
    headers: {
      Authorization: `Bearer ${authToken}`,
    },
  };
  const response = await instanceConexao.put(url, parameters, config);
  return response?.data;
};
